import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie";

const API_BASE_URL = process.env.REACT_APP_BASE_URL; // Replace with your actual API base URL
////console.log(API_BASE_URL, "API_BASE_URL");

// Fetch testimonials
export const fetchAllTestimonials = createAsyncThunk(
  "testimonials/fetchAllTestimonials",
  async (data, { rejectWithValue }) => {
    try {
      let {page,limit} = data
      const response = await axios.get(`${API_BASE_URL}/testimonials/fetch`, {
        params: { page, limit },
      });
      //console.log(response,"response")
      return response.data;
    } catch (error) {
      //console.log(error,"error")
      return rejectWithValue(error.response.data);
    }
  }
);
